<template>
	<div>
		<div class="giftAddress">
			<navBar>{{ title }}</navBar>
			<div class="content-box">
				<div v-if="address.length == 0">
					<div class="tupian font28">
						<p>详细地址示例:</p>
						<p class="mCG">
							公司:上地信息路甲28号科实大厦B座9层CD室
							<br />
							家庭:上地东里五区3号楼1单元XX室
						</p>
					</div>
					<div class="addressBut font34 mCf df-mc" @click="goPage(0)">添加收货地址</div>
				</div>
				<div v-else>
					<div class="itemAddress font28" v-for="(item, i) in address" :key="i">
						<div class="df-sb">
							<p>收货人：{{ item.name }}</p>
							<p>{{ item.phone }}</p>
						</div>
						<p class="mCG font24" style="margin-top: 0.1rem;">{{ item.province }} {{ item.city }} {{ item.area }} {{ item.address }}</p>
						<div class="morenbox df-a df-sb font26">
							<div class="left df-a" v-if="item.isdefault == 1">
								<img :src="icon2" alt="" />
								默认地址
							</div>
							<div class="mCG" v-else @click="setaddress(item)">设为默认地址</div>
							<div class="mCG df right">
								<div class="df-a" @click="editaddress(item)">
									<img :src="icon3" alt="" />
									编辑
								</div>
								<div class="df-a" @click="deladdress(item.id)">
									<img :src="icon4" alt="" />
									删除
								</div>
							</div>
						</div>
					</div>
					<div class="addressBut font34 mCf df-mc" @click="goPage(0)">新增地址</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { deepClone } from '@/utils/public';
export default {
	name: 'textBook',
	watch: {},
	data() {
		return {
			title: this.$route.query.title || '收礼品地址',
			icon1: require('../../assets/img/gift/icon-1.png'),
			icon2: require('../../assets/img/gift/icon-2.png'),
			icon3: require('../../assets/img/gift/icon-3.png'),
			icon4: require('../../assets/img/gift/icon-4.png'),
			isxuan: false,
			isAddress: true,
			address: []
		};
	},
	created() {
		this.getaddress();
	},
	methods: {
		deepClone,
		getaddress() {
			this.$api.getaddress({}).then((res) => {
				let resData = res.data?.data;
				this.address = resData;
			});
		},
		deladdress(id) {
			this.$dialog.confirm({
				title: '',
				message: '确认要删除该地址吗？'
			})
				.then(() => {
					this.$api
						.deladdress({addressid:id})
						.then((res) => {
							if(res.code==1){
								this.$toast({
									message: res.msg
								});
								this.getaddress()
							}
						});
				})
				.catch(() => {
					// on cancel
				});
			
		},
		editaddress(item) {
			this.$store.commit('common/setLianxiData2', item);
			this.goPage(1);
		},
		setaddress(item) {
			let apiData = this.deepClone(item);
			apiData.addressid = apiData.id;
			apiData.isdefault = 1;
			delete apiData.id;
			this.$api.editaddress(apiData).then((res) => {
				if (res.code == 1) {
					this.$toast({
						message: '设置成功'
					});
					setTimeout(() => {
						this.getaddress();
					}, 500);
				}
			});
		},
		goPage(type) {
			this.$router.push({
				path: '/addAddress',
				query: {
					type: type
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.giftAddress {
	height: calc(100% - 1.08rem);
	position: fixed;
	left: 0;
	right: 0;
	top: 1.08rem;
	overflow: auto;
	background: #f5faff;
	.content-box {
		padding: 0.25rem 0.28rem 0;
		.tupian {
			width: calc(100% - 0.28rem);
			height: 3.06rem;
			padding: 0.8rem 0.45rem 0;
			background: url('../../assets/img/gift/icon-1.png') no-repeat;
			background-size: 100% 100%;
			line-height: 0.5rem;
		}
		.addressBut {
			height: 0.8rem;
			background: #6b9bdb;
			border-radius: 0.4rem;
			margin-top: 0.4rem;
			margin-bottom: 0.4rem;
		}
		.itemAddress {
			width: 100%;
			// height: 2.6rem;
			background: #ffffff;
			border-radius: 0.1rem;
			padding: 0.3rem 0.28rem 1.1rem 0.28rem;
			position: relative;
			margin-bottom: 0.28rem;
			.morenbox {
				position: absolute;
				left: 0;
				bottom: 0;
				width: 100%;
				height: 0.9rem;
				border-top: 1px solid #dcdcdc;
				padding: 0 0.28rem;
				.left {
					color: #6b9bdb;
					img {
						width: 0.28rem;
						margin-right: 0.1rem;
					}
				}
				.right {
					img {
						width: 0.24rem;
						margin-right: 0.1rem;
					}
					& > div {
						margin-left: 0.28rem;
					}
				}
			}
		}
	}
}
</style>
